import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ViewChargingValueComponent } from '@catalog/products/view/tabs/view-characteristics/view-charging-value/view-charging-value.component';
import { ViewChargingComponent } from '@catalog/products/view/tabs/view-characteristics/view-charging/view-charging.component';
import { ReviewDetailComponent } from '@catalog/products/view/tabs/view-reviews/review-detail/review-detail.component';

import { ButtonModule, PriceModule, RatingModule, SliderModule, TabsModule } from '@trilogy';

import { BaseModule } from '../../../../base/base.module';
import { SharedForAllModule } from '../../../../base/shared-for-all.module';
import { ViewCharacteristicsComponent } from './view-characteristics/view-characteristics.component';
import { ViewNoteComponent } from './view-characteristics/view-note/view-note.component';
import { ViewDescriptionComponent } from './view-description/view-description.component';
import { ViewFaqComponent } from './view-faq/view-faq.component';
import { ViewReviewsComponent } from './view-reviews/view-reviews.component';
import { ViewTabsRenewComponent } from './view-tabs-renew/view-tabs-renew.component';
import { ViewTabsComponent } from './view-tabs.component';
import { ViewVideoComponent } from './view-video/view-video.component';

@NgModule({
    imports: [
        BaseModule,
        CommonModule,
        TabsModule,
        ButtonModule,
        RatingModule,
        SliderModule,
        PriceModule,
        FormsModule,
        SharedForAllModule,
        ReviewDetailComponent,
    ],
    declarations: [
        ViewDescriptionComponent,
        ViewCharacteristicsComponent,
        ViewReviewsComponent,
        ViewFaqComponent,
        ViewVideoComponent,
        ViewTabsComponent,
        ViewChargingComponent,
        ViewChargingValueComponent,
        ViewNoteComponent,
        ViewTabsRenewComponent,
    ],
    exports: [ViewTabsComponent, ViewTabsRenewComponent],
    providers: [],
})
export class ViewTabsModule {}
